import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function SocialProof() {
  const actions = ['2 live calls per month (strategy + implementation)', 'Access to the private FundHER Academy community', 'Funding insights, grant opportunities, and program breakdowns', 'Member-only activations and curated experiences', 'Giveaways, perks, and early access to LeadHerShip Equity events', 'Direct access to a community of women building boldly'];
  return <section className="py-24 lg:py-32 bg-maroon text-cream relative overflow-hidden" data-id="element-150">
      {/* Decorative background — mercury/silver glow */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-berry/10 rounded-l-full blur-3xl transform translate-x-1/3" data-id="element-151"></div>
      <div className="absolute bottom-[-20%] left-[-10%] w-[40%] h-[40%] bg-blush/5 blur-[100px] rounded-full" data-id="element-152"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-153">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-154">
          <div data-id="element-155">
            <FadeIn data-id="element-156">
              <div className="flex items-start gap-6 mb-8" data-id="element-157">
                <div className="w-24 h-24 rounded-full border border-blush/30 flex items-center justify-center relative flex-shrink-0" data-id="element-158">
                  <svg viewBox="0 0 150 150" className="absolute inset-0 w-full h-full animate-[spin_20s_linear_infinite]" data-id="element-159">
                    <path id="socialCirclePath" d="M 75, 75 m -55, 0 a 55,55 0 1,1 110,0 a 55,55 0 1,1 -110,0" fill="transparent" data-id="element-160" />
                    <text className="text-[10.5px] font-bold uppercase tracking-[0.15em] fill-blush" data-id="element-161">
                      <textPath href="#socialCirclePath" startOffset="0%" data-id="element-162">
                        LEADHERSHIP EQUITY • LEADHERSHIP EQUITY •
                      </textPath>
                    </text>
                  </svg>
                  <div className="text-center" data-id="element-163">
                    <div className="text-2xl font-serif text-blush leading-none" data-id="element-164">
                      LE
                    </div>
                    <div className="text-[7px] uppercase tracking-widest text-blush/70 mt-0.5" data-id="element-165">
                      EST 2019
                    </div>
                  </div>
                </div>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white" data-id="element-166">
                  What You Get Inside{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blush via-silver-light to-blush" data-id="element-167">
                    FundHER
                  </span>{' '}
                  Academy
                </h2>
              </div>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-168">
              <p className="text-xl text-blush-light/80 mb-8" data-id="element-169">
                LeadHerShip Equity is more than inspiration. It's a space where
                women take action.
              </p>
              <a href="https://buy.stripe.com/bJe14m74m5KjgWygiMf3a07" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-blush to-blush-light hover:from-blush-light hover:to-white text-maroon font-bold text-lg py-4 px-10 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl mb-12" data-id="element-170">
                Join FundHER Academy for $0.99
              </a>
            </FadeIn>
            <FadeIn delay={0.4} data-id="element-171">
              <p className="text-2xl font-serif italic text-white border-l-4 border-blush pl-6 py-2" data-id="element-172">
                We are building a community of women who are not just talking
                about entrepreneurship — they are actively building it.
              </p>
            </FadeIn>
          </div>

          <div className="bg-white/10 backdrop-blur-sm border-2 border-blush/20 rounded-2xl p-8 md:p-12 shadow-[0_0_40px_rgba(242,181,200,0.08)]" data-id="element-173">
            <FadeIn delay={0.2} data-id="element-174">
              <h3 className="font-serif mb-8 text-blush uppercase tracking-widest text-sm" data-id="element-175">
                Inside this community, members get:
              </h3>
            </FadeIn>

            <StaggerContainer className="space-y-6" data-id="element-176">
              {actions.map((action, index) => <StaggerItem key={index} className="flex items-center group" data-id="element-177">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blush/30 to-berry/30 flex items-center justify-center mr-4 group-hover:from-blush/50 group-hover:to-berry/50 transition-all duration-300 flex-shrink-0 border border-blush/20" data-id="element-178">
                    <ArrowRight className="w-4 h-4 text-blush" data-id="element-179" />
                  </div>
                  <span className="text-lg md:text-xl text-cream/90" data-id="element-180">
                    {action}
                  </span>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}